import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { DatasetFacade, PublishOption, PublishState } from '@mode/dataset/contract';
import { GithubFacade } from '@mode/github/contract';

@Component({
  selector: 'mode-dataset-header-dropdown',
  templateUrl: './dataset-header-dropdown.component.html',
  styleUrls: ['./dataset-header-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetHeaderDropdownComponent implements OnInit, OnDestroy {
  @Input() isDirty = false;
  @Input() isDisabled = false;
  @Input() datasetToken = 'not-provided';
  @Input() datasetShareLink = '';
  @Input() isPersonal = true;
  @Input() modeStudioEnabled = false;
  @Input() publishOption: PublishState = null;

  @Output() clickSave = new EventEmitter();
  @Output() datasetDeleted = new EventEmitter();
  @Output() navigateToDataset = new EventEmitter();
  @Output() clickUseInNewReport = new EventEmitter();
  @Output() publishOptionClicked = new EventEmitter<PublishOption>();

  private destroy$ = new Subject<void>();

  canSyncToGithub$ = this.githubFacade.canSyncToGithub$;
  getGithubLink$ = this.githubFacade.githubLink$;
  isSheetDataset$ = this.datasetFacade.isSheetDataset$;

  constructor(private datasetFacade: DatasetFacade, private githubFacade: GithubFacade) {}

  ngOnInit(): void {
    this.datasetFacade.deleted$
      .pipe(
        takeUntil(this.destroy$),
        filter((deleted) => deleted)
      )
      .subscribe(() => {
        setTimeout(() => this.datasetDeleted.emit(), 100);
      });
  }

  handleGithubSync(): void {
    this.githubFacade.dispatch(GithubFacade.Actions.datasetEditorHeaderPushedChangesToGithub());
  }

  handleSave() {
    this.clickSave.emit();
  }

  viewOrPreviewDataset() {
    this.navigateToDataset.emit();
  }

  handleUseInNewReport() {
    this.clickUseInNewReport.emit();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
